import React from 'react';
import { SelectableCardProps } from './types';
import './SelectableCard.css';

export const SelectableCard: React.FC<SelectableCardProps> = ({ title, selected, onClick, description, showImage, imageSrc }) => {
  return (
    <div className={`selectable-card ${selected ? 'selected' : ''}`} onClick={onClick}>
      <div className={`selectable-card__content`}>
        <div className={`selectable-card__title_label`}>{title}</div>
        <div className={`selectable-card__description`}>{description}</div>
      </div>
      {showImage && imageSrc &&
        <div className={`selectable-card__image`}>
          <img alt={""} src={imageSrc} />
        </div>
      }
    </div>
  );
}
